import { useEffect, useState } from "react";
import ButtonBlue from "../../components/ButtonBlue";
import useStyles from "./styles/herosection";
import LanguageButtonDark from "../../components/MultipleButton/LanguageButtonDark";
import { withTranslation } from "../../i18n";
import { getCFCountry } from "../../helpers/setCookie";

const ratingIcon = require("../../static/new-landing-page/wrath_white_appstore_playstore_2026.webp");
const ratingIconSm = require("../../static/new-landing-page/wrath_white_appstore_playstore_2026_440w.webp");
const awardIconV3 = require("../../static/new-landing-page/wreath_global_startup_v2.webp");
const awardIconV3Sm = require("../../static/new-landing-page/wreath_global_startup_v2_220w.webp");

const heroImageDesktopEN = require("../../static/new-landing-page/hero-section/en/desktop_hero_en.webp");
const heroImageMobileEN = require("../../static/new-landing-page/hero-section/en/mobile_hero_en.webp");
const heroImageDesktopID = require("../../static/new-landing-page/hero-section/id/desktop_hero_id.webp");
const heroImageMobileID = require("../../static/new-landing-page/hero-section/id/mobile_hero_id.webp");
// Pixel size of the webp files above. Without it the hero image is 0px tall until the
// file arrives, then pushes the rest of the page 520px down (PageSpeed desktop CLS 0.2,
// 19 Oct 2026). The browser only uses these for the ratio before load; the CSS width,
// max-height and object-fit still decide the final size, so nothing looks different.
const HERO_IMAGE_DESKTOP_SIZE = { width: 1121, height: 550 };
const HERO_IMAGE_MOBILE_SIZE = { en: { width: 664, height: 366 }, id: { width: 664, height: 362 } };

const HeroSection = ({
  t,
  i18n,
  redirect,
  page_source,
  hideLanguageButton: hideLanguageButtonProp = false,
  landingPageContent = null,
}) => {
  const currentLanguage = i18n.language;
  const [hideLanguageButtonState, setHideLanguageButtonState] = useState(false);
  useEffect(() => {
    const cfCountry = getCFCountry();
    const isOutsideIndonesia =
      cfCountry && String(cfCountry).toUpperCase() !== "ID";
    setHideLanguageButtonState(!!isOutsideIndonesia);
  }, []);
  const hideLanguageButton = hideLanguageButtonProp || hideLanguageButtonState;
  const heroImageDesktop =
    currentLanguage === "en" ? heroImageDesktopEN : heroImageDesktopID;
  const heroImageMobile =
    currentLanguage === "en" ? heroImageMobileEN : heroImageMobileID;
  const heroImageMobileSize =
    currentLanguage === "en" ? HERO_IMAGE_MOBILE_SIZE.en : HERO_IMAGE_MOBILE_SIZE.id;
  const classes = useStyles();

  // [Trello 399 14AUG-3] Returns null when no real percentage is available. This
  // used to fall back to 75, which is what made the CTA paint "Save 75%" before
  // the resolved value (40%) arrived.
  function formatPercentageValue(value, fallback = null) {
    if (value === null || value === undefined || value === "") {
      return fallback;
    }
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
      return fallback;
    }
    return Number.isInteger(parsedValue) ? parsedValue : parsedValue;
  }

  function getCustomButtonLabel() {
    switch (page_source) {
      case "/special":
      case "/redeem":
      case "collab":
        return t("get-started-now");
      default: {
        const percentage = formatPercentageValue(
          landingPageContent.highest_percentage
        );
        // Plain CTA rather than a placeholder discount.
        if (percentage === null) {
          return t("get-started-now");
        }
        return `${t("wlan-save")} ${percentage}%`;
      }
    }
  }

  function renderTextTitle() {
    if (currentLanguage === "id") {
      return (
        <h1 className={classes.title}>
          Turun Berat
          <br className={classes.breakMobile} />{" "}
          <span className={classes.breakDesktop}>& </span>
          Bentuk Badan
          <br />
          <span className={classes.gradientText}>Tanpa Ribet</span>
        </h1>
      );
    }
    return (
      <h1 className={classes.title}>
        Lose Weight
        <br className={classes.breakMobile} />{" "}
        <span className={classes.breakDesktop}>& </span>
        Get in Shape
        <br />
        <span className={classes.gradientText}>No Guesswork</span>
      </h1>
    );
  }

  function renderTitle() {
    return (
      <div className={classes.ctnTitle}>
        {renderTextTitle()}
        <span className={classes.subTitle}>
          {currentLanguage === "id"
            ? "Garansi 30 hari dapat hasil"
            : "30-Day Results Guarantee"}
        </span>
        <div className={classes.ctnButton}>
          <ButtonBlue onClick={redirect} label={getCustomButtonLabel()} />
        </div>
      </div>
    );
  }
  return (
    <div className={classes.mainContainer}>
      {!hideLanguageButton && (
        <div className={classes.ctnLanguageMobile}>
          <LanguageButtonDark />
        </div>
      )}
      <div className={classes.root}>
        <div className={classes.container}>
          {/* <div className={classes.ctnLanguageDesktop}>
                        <LanguageButtonDark />
                    </div> */}
          <div className={classes.ratingContainer}>
            <div className={classes.rating}>
              <img src={ratingIcon} srcSet={`${ratingIconSm} 440w, ${ratingIcon} 656w`} sizes="(min-width: 600px) 329px, 244px" alt="rating" />
            </div>
            {/* <div className={classes.award}>
                            <img src={awardIcon} alt="award" />
                        </div> */}
            {/* <div className={classes.awardV2}>
                            <img src={awardIconV2} alt="award-v2" />
                        </div> */}
            <div className={classes.awardV3}>
              <img src={awardIconV3} srcSet={`${awardIconV3Sm} 220w, ${awardIconV3} 308w`} sizes="(min-width: 600px) 154px, 115px" alt="award-v3" />
            </div>
          </div>
          {renderTitle()}
          <div className={classes.heroImage}>
            <picture>
              <source
                media="(max-width: 960px)"
                srcSet={heroImageMobile}
                width={heroImageMobileSize.width}
                height={heroImageMobileSize.height}
              />
              <img
                src={heroImageDesktop}
                alt={
                  currentLanguage === "id"
                    ? "Tampilan aplikasi Myfitsociety: dasbor harian, pencatatan makanan, latihan, asisten AI, dan papan peringkat"
                    : "Myfitsociety app screens: daily dashboard, meal tracking, a workout, the AI assistant and the leaderboard"
                }
                fetchpriority="high"
                width={HERO_IMAGE_DESKTOP_SIZE.width}
                height={HERO_IMAGE_DESKTOP_SIZE.height}
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation(["myfitsociety"])(HeroSection);
